var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseCatalogue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 1.5625H15.3125V11.625H16.625V1.34375C16.625 0.742188 16.1328 0.25 15.5312 0.25H1.96875C1.33984 0.25 0.875 0.742188 0.875 1.34375V11.625H2.1875V1.5625ZM17.0625 12.9375H14V10.75C14 10.2852 13.5898 9.875 13.125 9.875H7.875C7.38281 9.875 7 10.2852 7 10.75V12.9375H0.4375C0.191406 12.9375 0 13.1562 0 13.375V13.8125C0 14.0586 0.191406 14.25 0.4375 14.25H17.0625C17.2812 14.25 17.5 14.0586 17.5 13.8125V13.375C17.5 13.1562 17.2812 12.9375 17.0625 12.9375ZM12.6875 12.9375H8.3125V11.1875H12.6875V12.9375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseCatalogue);
export default __webpack_public_path__ + "static/media/course-catalogue.609f1d7c.svg";
export { ForwardRef as ReactComponent };